import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import FeatherIcon from 'feather-icons-react';

/**
 * 위젯 예제 캡처를 풀스크린 라이트박스로 보여주는 공용 컴포넌트.
 *
 * props:
 *   open    : boolean        — 라이트박스 표시 여부
 *   src     : string         — 표시할 이미지 URL (import 한 webpack asset 또는 URL)
 *   caption : string         — 하단 캡션 (위젯 이름)
 *   onClose : () => void     — 닫기 핸들러 (오버레이 클릭 / X / ESC)
 */
const PreviewLightbox = ({ open, src, caption, onClose }) => {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => { if (e.key === 'Escape' && typeof onClose === 'function') onClose(); };
        window.addEventListener('keydown', onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [open, onClose]);

    if (!open || !src) return null;

    return ReactDOM.createPortal(
        <div className="intro-lightbox"
             onClick={onClose}
             role="dialog"
             aria-modal="true"
             aria-label={(caption || '예제') + ' 확대 보기'}>
            <button type="button"
                    className="intro-lightbox__close"
                    onClick={(e) => { e.stopPropagation(); if (typeof onClose === 'function') onClose(); }}
                    title="닫기 (ESC)">
                <FeatherIcon icon="x" size="22" />
            </button>
            <figure className="intro-lightbox__figure" onClick={(e) => e.stopPropagation()}>
                <img src={src} alt={caption || ''} />
                {caption && <figcaption>{caption}</figcaption>}
            </figure>
        </div>,
        document.body
    );
};

export default PreviewLightbox;
